interface TestProps {}

export const Test = (props: TestProps) => {
  return <div style={{ textAlign: "center" }}></div>;
};
